import { useQuery } from '@tanstack/react-query';

import { useCompanyQuery } from '../company/useCompanyQuery';

import { competitorsApi } from './api';

export const makeCompetitorsQueryKey = (prospect: string) => ['competitors', prospect];

export const useCompetitorsQuery = () => {
  const { domain: prospect = '' } = useCompanyQuery().data ?? {};
  return useQuery({
    queryKey: makeCompetitorsQueryKey(prospect),
    queryFn: () => competitorsApi.getCompetitors(prospect),
    enabled: !!prospect,
  });
};
